import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingOverlay = ({ isVisible, message = "Зареждане..." }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white px-8 py-6 rounded-2xl shadow-2xl flex flex-col items-center justify-center space-y-4">
        <Loader2 className="w-10 h-10 text-tenant-primary animate-spin" />
        {message && (
          <p className="text-gray-700 font-medium text-[15px] text-center max-w-[250px]">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
